import React from "react";
import { Box, Skeleton, TablePagination, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LOG_CARD_INNER_BORDER, NodeLogCard } from "./NodeLogCard";
const HEADER_HEIGHT = 56;
const ROW_HEIGHT = 54;
/** The table area has this height whatever the number of rows, so the two log cards side by side stay level (more rows scroll). */
const TABLE_HEIGHT = 450;
const SKELETON_ROWS = 5;
/** Log table inside a card (Figma: Temp Log / Event Log - node 1.3). Server-paginated. */
export const NodeLogTableCard = ({ title, columns, rows, loading, emptyText, rowCount, paginationModel, onPaginationModelChange, pageSizeOptions = [25, 50], }) => {
    const { t } = useTranslation("common");
    const template = columns
        .map((col) => `minmax(${col.width}px, ${col.width}fr)`)
        .join(" ");
    const minWidth = columns.reduce((sum, col) => sum + col.width, 0);
    const cellSx = { display: "flex", alignItems: "center", px: 2, minWidth: 0 };
    return (React.createElement(NodeLogCard, { title: title },
        React.createElement(Box, { sx: {
                borderRadius: "32px",
                overflow: "hidden",
                boxShadow: LOG_CARD_INNER_BORDER,
                height: TABLE_HEIGHT,
            } },
            React.createElement(Box, { sx: { overflowX: "auto", height: "100%", overflowY: "auto" } },
                React.createElement(Box, { sx: { minWidth } },
                    React.createElement(Box, { role: "row", sx: {
                            display: "grid",
                            gridTemplateColumns: template,
                            height: HEADER_HEIGHT,
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                            backgroundColor: "#F4F6F8",
                        } }, columns.map((col) => (React.createElement(Typography, { key: col.field, role: "columnheader", variant: "subtitle2", noWrap: true, sx: Object.assign(Object.assign({}, cellSx), { fontWeight: 600, lineHeight: "24px", color: "text.secondary" }) }, col.header)))),
                    loading ? (Array.from({ length: SKELETON_ROWS }).map((_, i) => (React.createElement(Box, { key: i, sx: {
                            display: "grid",
                            gridTemplateColumns: template,
                            height: ROW_HEIGHT,
                            alignItems: "center",
                        } }, columns.map((col) => (React.createElement(Box, { key: col.field, sx: cellSx },
                        React.createElement(Skeleton, { variant: "text", width: "70%" })))))))) : rows.length === 0 ? (React.createElement(Box, { sx: {
                            height: ROW_HEIGHT,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        } },
                        React.createElement(Typography, { variant: "body2" }, emptyText))) : (rows.map((row) => (React.createElement(Box, { key: row.id, role: "row", sx: {
                            display: "grid",
                            gridTemplateColumns: template,
                            minHeight: ROW_HEIGHT,
                            alignItems: "center",
                        } }, columns.map((col) => {
                        var _a;
                        return (React.createElement(Typography, { key: col.field, role: "cell", variant: "body2", component: "div", noWrap: true, sx: cellSx }, col.render
                            ? col.render(row)
                            : String((_a = row[col.field]) !== null && _a !== void 0 ? _a : "")));
                    })))))))),
        rowCount > 0 && (React.createElement(TablePagination, { component: "div", count: rowCount, page: paginationModel.page, onPageChange: (_, page) => onPaginationModelChange({ page, pageSize: paginationModel.pageSize }), rowsPerPage: paginationModel.pageSize, onRowsPerPageChange: (event) => onPaginationModelChange({
                page: 0,
                pageSize: parseInt(event.target.value, 10),
            }), rowsPerPageOptions: pageSizeOptions, labelRowsPerPage: t("pagination.rowsPerPage") }))));
};
